export default __webpack_public_path__ + "static/media/logoBluefireAI.9ac89355.png";